import React from 'react';

const SearchedUserContext = React.createContext();

export default SearchedUserContext;
